export const SelectDefaultOptions = [
    { value: "Default Option 01", label: "Default Option 01" },
    { value: "Default Option 02", label: "Default Option 02" },
    { value: "Default Option 03", label: "Default Option 03" },
    { value: "Default Option 04", label: "Default Option 04" },
    { value: "Default Option 05", label: "Default Option 05" },
    { value: "Default Option 06", label: "Default Option 06" },
    { value: "Default Option 07", label: "Default Option 07" },
    { value: "Default Option 08", label: "Default Option 08" },
    { value: "Default Option 09", label: "Default Option 09" },
    { value: "Default Option 10", label: "Default Option 10" },
];

export const StatesOfTheUS = [
    { value: "Alabama", label: "Alabama" },
    { value: "Alaska", label: "Alaska" },
    { value: "American Samoa", label: "American Samoa" },
    { value: "Arizona", label: "Arizona" },
    { value: "Arkansas", label: "Arkansas" },
    { value: "California", label: "California" },
    { value: "Colorado", label: "Colorado" },
    { value: "Connecticut", label: "Connecticut" },
    { value: "Delaware", label: "Delaware" },
    { value: "District Of Columbia", label: "District Of Columbia" },
    { value: "Federated States Of Micronesia", label: "Federated States Of Micronesia" },
    { value: "Florida", label: "Florida" },
    { value: "Georgia", label: "Georgia" },
    { value: "Guam", label: "Guam" },
    { value: "Hawaii", label: "Hawaii" },
    { value: "Idaho", label: "Idaho" },
    { value: "Illinois", label: "Illinois" },
    { value: "Indiana", label: "Indiana" },
    { value: "Iowa", label: "Iowa" },
    { value: "Kansas", label: "Kansas" },
    { value: "Kentucky", label: "Kentucky" },
    { value: "Louisiana", label: "Louisiana" },
    { value: "Maine", label: "Maine" },
    { value: "Marshall Islands", label: "Marshall Islands" },
    { value: "Maryland", label: "Maryland" },
    { value: "Massachusetts", label: "Massachusetts" },
    { value: "Michigan", label: "Michigan" },
    { value: "Minnesota", label: "Minnesota" },
    { value: "Mississippi", label: "Mississippi" },
    { value: "Missouri", label: "Missouri" },
    { value: "Montana", label: "Montana" },
    { value: "Nebraska", label: "Nebraska" },
    { value: "Nevada", label: "Nevada" },
    { value: "New Hampshire", label: "New Hampshire" },
    { value: "New Jersey", label: "New Jersey" },
    { value: "New Mexico", label: "New Mexico" },
    { value: "New York", label: "New York" },
    { value: "North Carolina", label: "North Carolina" },
    { value: "North Dakota", label: "North Dakota" },
    { value: "Northern Mariana Islands", label: "Northern Mariana Islands" },
    { value: "Ohio", label: "Ohio" },
    { value: "Oklahoma", label: "Oklahoma" },
    { value: "Oregon", label: "Oregon" },
    { value: "Palau", label: "Palau" },
    { value: "Pennsylvania", label: "Pennsylvania" },
    { value: "Puerto Rico", label: "Puerto Rico" },
    { value: "Rhode Island", label: "Rhode Island" },
    { value: "South Carolina", label: "South Carolina" },
    { value: "South Dakota", label: "South Dakota" },
    { value: "Tennessee", label: "Tennessee" },
    { value: "Texas", label: "Texas" },
    { value: "Utah", label: "Utah" },
    { value: "Vermont", label: "Vermont" },
    { value: "Virgin Islands", label: "Virgin Islands" },
    { value: "Virginia", label: "Virginia" },
    { value: "Washington", label: "Washington" },
    { value: "West Virginia", label: "West Virginia" },
    { value: "Wisconsin", label: "Wisconsin" },
    { value: "Wyoming", label: "Wyoming" }
];

export const CitiesOfTheUS = [
    { value: "Aberdeen", label: "Aberdeen" },
    { value: "Abilene", label: "Abilene" },
    { value: "Akron", label: "Akron" },
    { value: "Albany", label: "Albany" },
    { value: "Albuquerque", label: "Albuquerque" },
    { value: "Alexandria", label: "Alexandria" },
    { value: "Allentown", label: "Allentown" },
    { value: "Amarillo", label: "Amarillo" },
    { value: "Anaheim", label: "Anaheim" },
    { value: "Anchorage", label: "Anchorage" },
    { value: "Ann Arbor", label: "Ann Arbor" },
    { value: "Antioch", label: "Antioch" },
    { value: "Apple Valley", label: "Apple Valley" },
    { value: "Appleton", label: "Appleton" },
    { value: "Arlington", label: "Arlington" },
    { value: "Arvada", label: "Arvada" },
    { value: "Asheville", label: "Asheville" },
    { value: "Athens", label: "Athens" },
    { value: "Atlanta", label: "Atlanta" },
    { value: "Atlantic City", label: "Atlantic City" },
    { value: "Augusta", label: "Augusta" },
    { value: "Aurora", label: "Aurora" },
    { value: "Austin", label: "Austin" },
    { value: "Bakersfield", label: "Bakersfield" },
    { value: "Baltimore", label: "Baltimore" },
    { value: "Barnstable", label: "Barnstable" },
    { value: "Baton Rouge", label: "Baton Rouge" },
    { value: "Beaumont", label: "Beaumont" },
    { value: "Bel Air", label: "Bel Air" },
    { value: "Bellevue", label: "Bellevue" },
    { value: "Berkeley", label: "Berkeley" },
    { value: "Bethlehem", label: "Bethlehem" },
    { value: "Billings", label: "Billings" },
    { value: "Birmingham", label: "Birmingham" },
    { value: "Bloomington", label: "Bloomington" },
    { value: "Boise", label: "Boise" },
    { value: "Boise City", label: "Boise City" },
    { value: "Bonita Springs", label: "Bonita Springs" },
    { value: "Boston", label: "Boston" },
    { value: "Boulder", label: "Boulder" },
    { value: "Bradenton", label: "Bradenton" },
    { value: "Bremerton", label: "Bremerton" },
    { value: "Bridgeport", label: "Bridgeport" },
    { value: "Brighton", label: "Brighton" },
    { value: "Brownsville", label: "Brownsville" },
    { value: "Bryan", label: "Bryan" },
    { value: "Buffalo", label: "Buffalo" },
    { value: "Burbank", label: "Burbank" },
    { value: "Burlington", label: "Burlington" },
    { value: "Cambridge", label: "Cambridge" },
    { value: "Canton", label: "Canton" },
    { value: "Cape Coral", label: "Cape Coral" },
    { value: "Carrollton", label: "Carrollton" },
    { value: "Cary", label: "Cary" },
    { value: "Cathedral City", label: "Cathedral City" },
    { value: "Cedar Rapids", label: "Cedar Rapids" },
    { value: "Champaign", label: "Champaign" },
    { value: "Chandler", label: "Chandler" },
    { value: "Charleston", label: "Charleston" },
    { value: "Charlotte", label: "Charlotte" },
    { value: "Chattanooga", label: "Chattanooga" },
    { value: "Chesapeake", label: "Chesapeake" },
    { value: "Chicago", label: "Chicago" },
    { value: "Chula Vista", label: "Chula Vista" },
    { value: "Cincinnati", label: "Cincinnati" },
    { value: "Clarke County", label: "Clarke County" },
    { value: "Clarksville", label: "Clarksville" },
    { value: "Clearwater", label: "Clearwater" },
    { value: "Cleveland", label: "Cleveland" },
    { value: "College Station", label: "College Station" },
    { value: "Colorado Springs", label: "Colorado Springs" },
    { value: "Columbia", label: "Columbia" },
    { value: "Columbus", label: "Columbus" },
    { value: "Concord", label: "Concord" },
    { value: "Coral Springs", label: "Coral Springs" },
    { value: "Corona", label: "Corona" },
    { value: "Corpus Christi", label: "Corpus Christi" },
    { value: "Costa Mesa", label: "Costa Mesa" },
    { value: "Dallas", label: "Dallas" },
    { value: "Daly City", label: "Daly City" },
    { value: "Danbury", label: "Danbury" },
    { value: "Davenport", label: "Davenport" },
    { value: "Davidson County", label: "Davidson County" },
    { value: "Dayton", label: "Dayton" },
    { value: "Daytona Beach", label: "Daytona Beach" },
    { value: "Deltona", label: "Deltona" },
    { value: "Denton", label: "Denton" },
    { value: "Denver", label: "Denver" },
    { value: "Des Moines", label: "Des Moines" },
    { value: "Detroit", label: "Detroit" },
    { value: "Downey", label: "Downey" },
    { value: "Duluth", label: "Duluth" },
    { value: "Durham", label: "Durham" },
    { value: "El Monte", label: "El Monte" },
    { value: "El Paso", label: "El Paso" },
    { value: "Elizabeth", label: "Elizabeth" },
    { value: "Elk Grove", label: "Elk Grove" },
    { value: "Elkhart", label: "Elkhart" },
    { value: "Erie", label: "Erie" },
    { value: "Escondido", label: "Escondido" },
    { value: "Eugene", label: "Eugene" },
    { value: "Evansville", label: "Evansville" },
    { value: "Fairfield", label: "Fairfield" },
    { value: "Fargo", label: "Fargo" },
    { value: "Fayetteville", label: "Fayetteville" },
    { value: "Fitchburg", label: "Fitchburg" },
    { value: "Flint", label: "Flint" },
    { value: "Fontana", label: "Fontana" },
    { value: "Fort Collins", label: "Fort Collins" },
    { value: "Fort Lauderdale", label: "Fort Lauderdale" },
    { value: "Fort Smith", label: "Fort Smith" },
    { value: "Fort Walton Beach", label: "Fort Walton Beach" },
    { value: "Fort Wayne", label: "Fort Wayne" },
    { value: "Fort Worth", label: "Fort Worth" },
    { value: "Frederick", label: "Frederick" },
    { value: "Fremont", label: "Fremont" },
    { value: "Fresno", label: "Fresno" },
    { value: "Fullerton", label: "Fullerton" },
    { value: "Gainesville", label: "Gainesville" },
    { value: "Garden Grove", label: "Garden Grove" },
    { value: "Garland", label: "Garland" },
    { value: "Gastonia", label: "Gastonia" },
    { value: "Gilbert", label: "Gilbert" },
    { value: "Glendale", label: "Glendale" },
    { value: "Grand Prairie", label: "Grand Prairie" },
    { value: "Grand Rapids", label: "Grand Rapids" },
    { value: "Grayslake", label: "Grayslake" },
    { value: "Green Bay", label: "Green Bay" },
    { value: "GreenBay", label: "GreenBay" },
    { value: "Greensboro", label: "Greensboro" },
    { value: "Greenville", label: "Greenville" },
    { value: "Gulfport-Biloxi", label: "Gulfport-Biloxi" },
    { value: "Hagerstown", label: "Hagerstown" },
    { value: "Hampton", label: "Hampton" },
    { value: "Harlingen", label: "Harlingen" },
    { value: "Harrisburg", label: "Harrisburg" },
    { value: "Hartford", label: "Hartford" },
    { value: "Havre de Grace", label: "Havre de Grace" },
    { value: "Hayward", label: "Hayward" },
    { value: "Hemet", label: "Hemet" },
    { value: "Henderson", label: "Henderson" },
    { value: "Hesperia", label: "Hesperia" },
    { value: "Hialeah", label: "Hialeah" },
    { value: "Hickory", label: "Hickory" },
    { value: "High Point", label: "High Point" },
    { value: "Hollywood", label: "Hollywood" },
    { value: "Honolulu", label: "Honolulu" },
    { value: "Houma", label: "Houma" },
    { value: "Houston", label: "Houston" },
    { value: "Howell", label: "Howell" },
    { value: "Huntington", label: "Huntington" },
    { value: "Huntington Beach", label: "Huntington Beach" },
    { value: "Huntsville", label: "Huntsville" },
    { value: "Independence", label: "Independence" },
    { value: "Indianapolis", label: "Indianapolis" },
    { value: "Inglewood", label: "Inglewood" },
    { value: "Irvine", label: "Irvine" },
    { value: "Irving", label: "Irving" },
    { value: "Jackson", label: "Jackson" },
    { value: "Jacksonville", label: "Jacksonville" },
    { value: "Jefferson", label: "Jefferson" },
    { value: "Jersey City", label: "Jersey City" },
    { value: "Johnson City", label: "Johnson City" },
    { value: "Joliet", label: "Joliet" },
    { value: "Kailua", label: "Kailua" },
    { value: "Kalamazoo", label: "Kalamazoo" },
    { value: "Kaneohe", label: "Kaneohe" },
    { value: "Kansas City", label: "Kansas City" },
    { value: "Kennewick", label: "Kennewick" },
    { value: "Kenosha", label: "Kenosha" },
    { value: "Killeen", label: "Killeen" },
    { value: "Kissimmee", label: "Kissimmee" },
    { value: "Knoxville", label: "Knoxville" },
    { value: "Lacey", label: "Lacey" },
    { value: "Lafayette", label: "Lafayette" },
    { value: "Lake Charles", label: "Lake Charles" },
    { value: "Lakeland", label: "Lakeland" },
    { value: "Lakewood", label: "Lakewood" },
    { value: "Lancaster", label: "Lancaster" },
    { value: "Lansing", label: "Lansing" },
    { value: "Laredo", label: "Laredo" },
    { value: "Las Cruces", label: "Las Cruces" },
    { value: "Las Vegas", label: "Las Vegas" },
    { value: "Layton", label: "Layton" },
    { value: "Leominster", label: "Leominster" },
    { value: "Lewisville", label: "Lewisville" },
    { value: "Lexington", label: "Lexington" },
    { value: "Lincoln", label: "Lincoln" },
    { value: "Little Rock", label: "Little Rock" },
    { value: "Long Beach", label: "Long Beach" },
    { value: "Lorain", label: "Lorain" },
    { value: "Los Angeles", label: "Los Angeles" },
    { value: "Louisville", label: "Louisville" },
    { value: "Lowell", label: "Lowell" },
    { value: "Lubbock", label: "Lubbock" },
    { value: "Macon", label: "Macon" },
    { value: "Madison", label: "Madison" },
    { value: "Manchester", label: "Manchester" },
    { value: "Marina", label: "Marina" },
    { value: "Marysville", label: "Marysville" },
    { value: "McAllen", label: "McAllen" },
    { value: "McHenry", label: "McHenry" },
    { value: "Medford", label: "Medford" },
    { value: "Melbourne", label: "Melbourne" },
    { value: "Memphis", label: "Memphis" },
    { value: "Merced", label: "Merced" },
    { value: "Mesa", label: "Mesa" },
    { value: "Mesquite", label: "Mesquite" },
    { value: "Miami", label: "Miami" },
    { value: "Milwaukee", label: "Milwaukee" },
    { value: "Minneapolis", label: "Minneapolis" },
    { value: "Miramar", label: "Miramar" },
    { value: "Mission Viejo", label: "Mission Viejo" },
    { value: "Mobile", label: "Mobile" },
    { value: "Modesto", label: "Modesto" },
    { value: "Monroe", label: "Monroe" },
    { value: "Monterey", label: "Monterey" },
    { value: "Montgomery", label: "Montgomery" },
    { value: "Moreno Valley", label: "Moreno Valley" },
    { value: "Murfreesboro", label: "Murfreesboro" },
    { value: "Murrieta", label: "Murrieta" },
    { value: "Muskegon", label: "Muskegon" },
    { value: "Myrtle Beach", label: "Myrtle Beach" },
    { value: "Naperville", label: "Naperville" },
    { value: "Naples", label: "Naples" },
    { value: "Nashua", label: "Nashua" },
    { value: "Nashville", label: "Nashville" },
    { value: "New Bedford", label: "New Bedford" },
    { value: "New Haven", label: "New Haven" },
    { value: "New London", label: "New London" },
    { value: "New Orleans", label: "New Orleans" },
    { value: "New York", label: "New York" },
    { value: "New York City", label: "New York City" },
    { value: "Newark", label: "Newark" },
    { value: "Newburgh", label: "Newburgh" },
    { value: "Newport News", label: "Newport News" },
    { value: "Norfolk", label: "Norfolk" },
    { value: "Normal", label: "Normal" },
    { value: "Norman", label: "Norman" },
    { value: "North Charleston", label: "North Charleston" },
    { value: "North Las Vegas", label: "North Las Vegas" },
    { value: "North Port", label: "North Port" },
    { value: "Norwalk", label: "Norwalk" },
    { value: "Norwich", label: "Norwich" },
    { value: "Oakland", label: "Oakland" },
    { value: "Ocala", label: "Ocala" },
    { value: "Oceanside", label: "Oceanside" },
    { value: "Odessa", label: "Odessa" },
    { value: "Ogden", label: "Ogden" },
    { value: "Oklahoma City", label: "Oklahoma City" },
    { value: "Olathe", label: "Olathe" },
    { value: "Olympia", label: "Olympia" },
    { value: "Omaha", label: "Omaha" },
    { value: "Ontario", label: "Ontario" },
    { value: "Orange", label: "Orange" },
    { value: "Orem", label: "Orem" },
    { value: "Orlando", label: "Orlando" },
    { value: "Overland Park", label: "Overland Park" },
    { value: "Oxnard", label: "Oxnard" },
    { value: "Palm Bay", label: "Palm Bay" },
    { value: "Palm Springs", label: "Palm Springs" },
    { value: "Palmdale", label: "Palmdale" },
    { value: "Panama City", label: "Panama City" },
    { value: "Pasadena", label: "Pasadena" },
    { value: "Paterson", label: "Paterson" },
    { value: "Pembroke Pines", label: "Pembroke Pines" },
    { value: "Pensacola", label: "Pensacola" },
    { value: "Peoria", label: "Peoria" },
    { value: "Philadelphia", label: "Philadelphia" },
    { value: "Phoenix", label: "Phoenix" },
    { value: "Pittsburgh", label: "Pittsburgh" },
    { value: "Plano", label: "Plano" },
    { value: "Pomona", label: "Pomona" },
    { value: "Pompano Beach", label: "Pompano Beach" },
    { value: "Port Arthur", label: "Port Arthur" },
    { value: "Port Orange", label: "Port Orange" },
    { value: "Port Saint Lucie", label: "Port Saint Lucie" },
    { value: "Port St. Lucie", label: "Port St. Lucie" },
    { value: "Portland", label: "Portland" },
    { value: "Portsmouth", label: "Portsmouth" },
    { value: "Poughkeepsie", label: "Poughkeepsie" },
    { value: "Providence", label: "Providence" },
    { value: "Provo", label: "Provo" },
    { value: "Pueblo", label: "Pueblo" },
    { value: "Punta Gorda", label: "Punta Gorda" },
    { value: "Racine", label: "Racine" },
    { value: "Raleigh", label: "Raleigh" },
    { value: "Rancho Cucamonga", label: "Rancho Cucamonga" },
    { value: "Reading", label: "Reading" },
    { value: "Redding", label: "Redding" },
    { value: "Reno", label: "Reno" },
    { value: "Richland", label: "Richland" },
    { value: "Richmond", label: "Richmond" },
    { value: "Richmond County", label: "Richmond County" },
    { value: "Riverside", label: "Riverside" },
    { value: "Roanoke", label: "Roanoke" },
    { value: "Rochester", label: "Rochester" },
    { value: "Rockford", label: "Rockford" },
    { value: "Roseville", label: "Roseville" },
    { value: "Round Lake Beach", label: "Round Lake Beach" },
    { value: "Sacramento", label: "Sacramento" },
    { value: "Saginaw", label: "Saginaw" },
    { value: "Saint Louis", label: "Saint Louis" },
    { value: "Saint Paul", label: "Saint Paul" },
    { value: "Saint Petersburg", label: "Saint Petersburg" },
    { value: "Salem", label: "Salem" },
    { value: "Salinas", label: "Salinas" },
    { value: "Salt Lake City", label: "Salt Lake City" },
    { value: "San Antonio", label: "San Antonio" },
    { value: "San Bernardino", label: "San Bernardino" },
    { value: "San Buenaventura", label: "San Buenaventura" },
    { value: "San Diego", label: "San Diego" },
    { value: "San Francisco", label: "San Francisco" },
    { value: "San Jose", label: "San Jose" },
    { value: "Santa Ana", label: "Santa Ana" },
    { value: "Santa Barbara", label: "Santa Barbara" },
    { value: "Santa Clara", label: "Santa Clara" },
    { value: "Santa Clarita", label: "Santa Clarita" },
    { value: "Santa Cruz", label: "Santa Cruz" },
    { value: "Santa Maria", label: "Santa Maria" },
    { value: "Santa Rosa", label: "Santa Rosa" },
    { value: "Sarasota", label: "Sarasota" },
    { value: "Savannah", label: "Savannah" },
    { value: "Scottsdale", label: "Scottsdale" },
    { value: "Scranton", label: "Scranton" },
    { value: "Seaside", label: "Seaside" },
    { value: "Seattle", label: "Seattle" },
    { value: "Sebastian", label: "Sebastian" },
    { value: "Shreveport", label: "Shreveport" },
    { value: "Simi Valley", label: "Simi Valley" },
    { value: "Sioux City", label: "Sioux City" },
    { value: "Sioux Falls", label: "Sioux Falls" },
    { value: "South Bend", label: "South Bend" },
    { value: "South Lyon", label: "South Lyon" },
    { value: "Spartanburg", label: "Spartanburg" },
    { value: "Spokane", label: "Spokane" },
    { value: "Springdale", label: "Springdale" },
    { value: "Springfield", label: "Springfield" },
    { value: "St. Louis", label: "St. Louis" },
    { value: "St. Paul", label: "St. Paul" },
    { value: "St. Petersburg", label: "St. Petersburg" },
    { value: "Stamford", label: "Stamford" },
    { value: "Sterling Heights", label: "Sterling Heights" },
    { value: "Stockton", label: "Stockton" },
    { value: "Sunnyvale", label: "Sunnyvale" },
    { value: "Syracuse", label: "Syracuse" },
    { value: "Tacoma", label: "Tacoma" },
    { value: "Tallahassee", label: "Tallahassee" },
    { value: "Tampa", label: "Tampa" },
    { value: "Temecula", label: "Temecula" },
    { value: "Tempe", label: "Tempe" },
    { value: "Thornton", label: "Thornton" },
    { value: "Thousand Oaks", label: "Thousand Oaks" },
    { value: "Toledo", label: "Toledo" },
    { value: "Topeka", label: "Topeka" },
    { value: "Torrance", label: "Torrance" },
    { value: "Trenton", label: "Trenton" },
    { value: "Tucson", label: "Tucson" },
    { value: "Tulsa", label: "Tulsa" },
    { value: "Tuscaloosa", label: "Tuscaloosa" },
    { value: "Tyler", label: "Tyler" },
    { value: "Utica", label: "Utica" },
    { value: "Vallejo", label: "Vallejo" },
    { value: "Vancouver", label: "Vancouver" },
    { value: "Vero Beach", label: "Vero Beach" },
    { value: "Victorville", label: "Victorville" },
    { value: "Virginia Beach", label: "Virginia Beach" },
    { value: "Visalia", label: "Visalia" },
    { value: "Waco", label: "Waco" },
    { value: "Warren", label: "Warren" },
    { value: "Washington", label: "Washington" },
    { value: "Waterbury", label: "Waterbury" },
    { value: "Waterloo", label: "Waterloo" },
    { value: "West Covina", label: "West Covina" },
    { value: "West Valley City", label: "West Valley City" },
    { value: "Westminster", label: "Westminster" },
    { value: "Wichita", label: "Wichita" },
    { value: "Wilmington", label: "Wilmington" },
    { value: "Winston", label: "Winston" },
    { value: "Winter Haven", label: "Winter Haven" },
    { value: "Worcester", label: "Worcester" },
    { value: "Yakima", label: "Yakima" },
    { value: "Yonkers", label: "Yonkers" },
    { value: "York", label: "York" },
    { value: "Youngstown", label: "Youngstown" },
];

export const SelectTimeOptions = [
    { value: "Afternoon", label: "Afternoon" },
    { value: "Morning", label: "Morning" },
    { value: "Evening", label: "Evening" },
];

export const SelectDaysOptions = [
    { value: "Monday", label: "Monday" },
    { value: "Tuesday", label: "Tuesday" },
    { value: "Wednesday", label: "Wednesday" },
    { value: "Thursday", label: "Thursday" },
    { value: "Friday", label: "Friday" },
    { value: "Saturday", label: "Saturday" },
    { value: "Sunday", label: "Sunday" },
    
];
export const SelectBlogsCategoriesOptions = [
    { value: "HR Management & Planning", label: "HR Management & Planning" },
    { value: "Employee Retention & Benfits", label: "Employee Retention & Benfits" },
    { value: "Manage Your Brand", label: "Manage Your Brand" },
    { value: "How To Use Metropolis", label: "How To Use Metropolis" },
    { value: "Employee Engagement", label: "Employee Engagement" },
    { value: "Hiring & Recruiting", label: "Hiring & Recruiting" },    
];
export const SelectGenderOptions = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },    
];
export const SelectBirthYearOptions = [
    { value: "2021", label: "2021" },
    { value: "2020", label: "2020" },    
    { value: "2019", label: "2019" },    
    { value: "2018", label: "2018" },    
    { value: "2017", label: "2017" },    
    { value: "2016", label: "2016" },    
    { value: "2015", label: "2015" },    
    { value: "2014", label: "2014" },    
    { value: "2013", label: "2013" },    
    { value: "2012", label: "2012" },    
    { value: "2011", label: "2011" },    
    { value: "2010", label: "2010" },    
    { value: "2009", label: "2009" },    
    { value: "2008", label: "2008" },    
    { value: "2007", label: "2007" },    
    { value: "2006", label: "2006" },    
    { value: "2005", label: "2005" },    
    { value: "2004", label: "2004" },    
    { value: "2003", label: "2003" },    
    { value: "2002", label: "2002" },    
    { value: "2001", label: "2001" },    
    { value: "2000", label: "2000" },    
    { value: "1999", label: "1999" },        
    { value: "1998", label: "1998" },        
    { value: "1997", label: "1997" },        
    { value: "1996", label: "1996" },        
    { value: "1995", label: "1995" },        
    { value: "1994", label: "1994" },        
    { value: "1993", label: "1993" },        
    { value: "1992", label: "1992" },        
    { value: "1991", label: "1991" },        
    { value: "1990", label: "1990" },        
];
export const SelectHighestEducationOptions = [
    { value: "Secondary Education", label: "Secondary Education" },
    { value: "First University Degree", label: "First University Degree" },    
    { value: "Post-Graduate University Degree", label: "Post-Graduate University Degree" },    
];
